(function () {
  function collectRowsByUid(uid) {
    return Array.from(document.querySelectorAll('tr.cart-item'))
      .filter(r => r.dataset.bundleUid && r.dataset.bundleUid === uid);
  }

  function removeBundleByUid(uid) {
    const rows = collectRowsByUid(uid);
    if (!rows.length) return Promise.resolve();

    const updates = {};
    rows.forEach(r => {
      const key = r.dataset.lineKey;
      if (key) updates[key] = 0;
    });

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates })
    })
      .then(r => r.json())
      .then(() => {
        window.location.reload();
      })
      .catch(() => window.location.reload());
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('cart-remove-button .button, a[href*="/cart/change"]');
    if (!btn) return;

    const row = btn.closest('tr.cart-item');
    if (!row) return;

    if (row.dataset.isParent === '1' && row.dataset.bundleUid) {
      e.preventDefault();
      e.stopPropagation();
      removeBundleByUid(row.dataset.bundleUid);
    }
  }, true);

  document.addEventListener('change', function (e) {
    const input = e.target.closest('.quantity__input');
    if (!input) return;

    const row = input.closest('tr.cart-item');
    if (!row) return;

    if (row.dataset.isParent === '1' && row.dataset.bundleUid && Number(input.value) === 0) {
      input.value = 1;
      e.preventDefault();
      e.stopPropagation();
      removeBundleByUid(row.dataset.bundleUid);
    }
  }, true);
})();
